import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { reservationGuard } from './core/guards/reservation.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./modules/login/login').then((m) => m.Login),
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: 'post-login-flow',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/post-login-flow/post-login-flow').then((m) => m.PostLoginFlow),
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: 'main',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/main-screen/main-screen').then((m) => m.MainScreen),
    data: {
      breadcrumb: { label: 'MAIN SCREEN' },
    },
  },
  {
    path: 'log-out',
    canActivate: [authGuard],
    loadComponent: () => import('./modules/log-out/log-out').then((m) => m.LogOut),
    data: {
      breadcrumb: { label: 'LOG OUT' },
    },
  },
  {
    path: 'book-reservation',
    canActivate: [reservationGuard],
    loadComponent: () =>
      import('./modules/book-reservation/book-reservation.component').then(
        (m) => m.BookReservationComponent,
      ),
    data: {
      breadcrumb: { label: 'BOOK RESERVATION' },
    },
  },
  {
    path: 'settings',
    canActivate: [],
    loadComponent: () => import('./modules/settings/settings').then((m) => m.Settings),
    data: {
      breadcrumb: { label: 'SETTINGS' },
    },
  },
];
